import React from 'react';
import { CLINIC_INFO, DOCTORS_DEFAULT } from '../utils/constants';

const About = () => {
    return (
        <div className="page">
            <section className="section">
                <h2>About {CLINIC_INFO.name}</h2>
                <p style={{ fontSize: '16px', lineHeight: '1.8', margin: '20px 0', textAlign:'justify' }}>
                    At {CLINIC_INFO.name}, we were established with a simple mission: to provide high-quality,
pain-free dental care at a reasonable cost, always in line with the most updated clinical guidelines.
We use modern dental technology and high-quality materials, and we place strong emphasis on
understanding each patient’s individual needs.
                </p>

                <p style={{ fontSize: '16px', lineHeight: '1.8', margin: '20px 0', textAlign:'justify' }}>
                    We want your visit to feel like you’re coming to a trusted friend. Our two dedicated dental surgeons,
Dr. Sudeha Duwagamge and Dr. K. A. Gammulle, each hold both basic and postgraduate dental
degrees (BDS (SL) and MSc (Colombo)). They bring nearly 14 years of experience from both
government and private practices and are deeply committed to continuous learning. 
                </p>

                <p style={{ fontSize: '16px', lineHeight: '1.8', margin: '20px 0', textAlign:'justify' }}>
                     They regularly
update their skills through various workshops and advanced training, ensuring they stay at the
forefront of dental advancements. Alongside them, our well-trained nurses ensure a warm,
family-friendly environment and uphold the highest standards of care and sterilization.
                </p>

                {/* Clinic Images */}
                {/* <div className="grid grid-2" style={{ margin: '40px 0' }}>
                    <div className="service-card">
                        <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            width: '100%',
                            height: '200px',
                            borderRadius: '8px',
                            marginBottom: '15px'
                        }}></div>
                        <h3>Modern Clinic</h3>
                    </div>
                    <div className="service-card">
                        <div style={{
                            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                            width: '100%',
                            height: '200px',
                            borderRadius: '8px',
                            marginBottom: '15px'
                        }}></div>
                        <h3>Sterilized Equipment</h3>
                    </div>
                    <div className="service-card">
                        <div style={{
                            background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                            width: '100%',
                            height: '200px',
                            borderRadius: '8px',
                            marginBottom: '15px'
                        }}></div>
                        <h3>Comfortable Environment</h3>
                    </div>
                </div> */}

                {/* Mission & Vision */}
                {/* <div className="mission-vision">
                    <div className="mv-box">
                        <h3>Our Mission</h3>
                        <p>To provide world-class dental care with compassion, utilizing the latest technology and techniques to ensure every patient leaves with a healthy and beautiful smile.</p>
                    </div>
                    <div className="mv-box">
                        <h3>Our Vision</h3>
                        <p>To be the most trusted and preferred dental clinic in the region, known for excellence in patient care and innovative dental solutions.</p>
                    </div>
                    <div className="mv-box">
                        <h3>Our Values</h3>
                        <p>Patient-first approach, professional excellence, continuous learning, ethical practice, and community care.</p>
                    </div>
                </div> */}

                {/* Doctor Profiles */}
                <h2 style={{ marginTop: '50px', marginBottom: '30px' }}>Meet Our Doctors</h2>
                <div className="doctor-grid">
                    {DOCTORS_DEFAULT.map(doctor => (
                        <div key={doctor.id} className="doctor-card">
                            <div className="doctor-image">{doctor.image}</div>
                            <h3>{doctor.name}</h3>
                            <div className="doctor-specialty">{doctor.specialty}</div>
                            <p>{doctor.experience}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default About;
